"use client";

import { Facebook, Instagram, Twitter, Linkedin } from "lucide-react";

export default function FooterBottom() {
  const socialLinks = [
    { icon: Facebook, href: "#", label: "Facebook" },
    { icon: Instagram, href: "#", label: "Instagram" },
    { icon: Twitter, href: "#", label: "Twitter" },
    { icon: Linkedin, href: "#", label: "LinkedIn" },
  ];

  return (
    <div className="border-t border-gray-800">
      <div className="flex flex-col lg:flex-row justify-between items-center py-8 space-y-6 lg:space-y-0">
        {/* Left Side - Copyright & ABN */}
        <div className="flex flex-col lg:flex-row items-center space-y-2 lg:space-y-0 lg:space-x-8">
          <div className="text-gray-400 text-base font-body">
            © {new Date().getFullYear()} R&R Equipment Rentals. All rights reserved.
          </div>
          <div className="text-gray-500 text-sm font-body">
            ABN: 84 684 462 315
          </div>
        </div>

        {/* Center - Social Links */}
        <div className="flex items-center space-x-1">
          {socialLinks.map((social) => {
            const IconComponent = social.icon;
            return (
              <a
                key={social.label}
                href={social.href}
                aria-label={social.label}
                className="w-12 h-12 bg-gray-900 rounded-xl flex items-center justify-center text-gray-400 hover:bg-[var(--color-rr-green)] hover:text-black transition-all duration-300 hover:scale-110"
              >
                <IconComponent size={20} />
              </a>
            );
          })}
        </div>

        {/* Right Side - Legal Links */}
        <div className="flex items-center space-x-6">
          <a href="/terms" className="text-gray-400 hover:text-white text-sm font-body transition-colors">
            Terms
          </a>
          <a href="/privacy" className="text-gray-400 hover:text-white text-sm font-body transition-colors">
            Privacy
          </a>
        </div>
      </div>
    </div>
  );
}